// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"50cdd986","732":"a8969355","977":"9239b53b"}[chunkId] + ".chunk.js";
};